export default function <T>(a: T[], sortFun: (a: T, b: T) => number) {
    return a.slice().sort(sortFun);
}
